export * from "./typography.component";
